import { CIcon } from '~/icons/types'

export const ciQuestionCircle: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 15.26a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM14.78 12a3.827 3.827 0 0 1-.89.59 1.77 1.77 0 0 0-.89 1.1 1.21 1.21 0 0 0 0 .38 1 1 0 0 1-.8 1.16h-.18a1 1 0 0 1-1-.82 3 3 0 0 1 0-1.12 3.739 3.739 0 0 1 2-2.54 1.86 1.86 0 0 0 .44-.29A1.469 1.469 0 0 0 14 9.37a1.57 1.57 0 0 0-.48-1 2.41 2.41 0 0 0-1.38-.6 2.6 2.6 0 0 0-1.72.42c-.37.21-.65.548-.79.95a1.3 1.3 0 0 0 0 .59 1.016 1.016 0 1 1-2 .36 3.37 3.37 0 0 1 .05-1.45 3.71 3.71 0 0 1 1.6-2.14 4.65 4.65 0 0 1 3.09-.77 4.25 4.25 0 0 1 2.42 1l.12.11A3.58 3.58 0 0 1 16 9.37 3.43 3.43 0 0 1 14.78 12Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'question-circle',
  type: 'solid'
}
